import styled from '@emotion/styled';

import { UnsavedChangesPrompt } from 'components/common/zolaUI/Drawer/Drawer.styles';

export const Container = styled(UnsavedChangesPrompt)`
  max-width: 312px;
`;
